var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopIconGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_3114801",
    clipPath: "url(#clip0_40088_211579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 0.5C4.91221 0.5 3.84884 0.822569 2.94437 1.42692C2.0399 2.03126 1.33495 2.89025 0.918665 3.89524C0.502383 4.90023 0.393465 6.0061 0.605683 7.073C0.817902 8.13989 1.34173 9.1199 2.11092 9.88909C2.8801 10.6583 3.86011 11.1821 4.92701 11.3943C5.9939 11.6065 7.09977 11.4976 8.10476 11.0813C9.10976 10.6651 9.96874 9.96011 10.5731 9.05564C11.1774 8.15117 11.5 7.0878 11.5 6C11.4983 4.54184 10.9183 3.14389 9.88719 2.11281C8.85611 1.08174 7.45817 0.50172 6 0.5ZM1.5 6C1.4996 4.97958 1.84803 3.98969 2.4875 3.1945L8.8055 9.5125C8.14426 10.0425 7.34664 10.3748 6.50468 10.471C5.66271 10.5672 4.8107 10.4234 4.04695 10.0562C3.2832 9.68895 2.63882 9.11329 2.18817 8.3956C1.73752 7.67792 1.49896 6.84744 1.5 6ZM9.5125 8.8055L3.1945 2.4875C4.05812 1.7952 5.14682 1.44592 6.252 1.50658C7.35718 1.56724 8.40111 2.03358 9.18377 2.81624C9.96642 3.59889 10.4328 4.64283 10.4934 5.74801C10.5541 6.85319 10.2048 7.94189 9.5125 8.8055Z",
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40088_211579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIconGrey);
export default __webpack_public_path__ + "static/media/StopIconGrey.bbcd98f4867fd3ae30f8d96dc7d5eb32.svg";
export { ForwardRef as ReactComponent };